/**
 * User role types
 */
export enum UserRole {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Member = 'Member',
}

/**
 * Timezone options
 */
export enum Timezone {
  UTC = 'UTC',
  EST = 'EST',
  CST = 'CST',
  MST = 'MST',
  PST = 'PST',
}

/**
 * User status types
 */
export enum UserStatus {
  Online = 'Online',
  OnlineReadyToChat = 'Online and ready to chat',
  OnlineInDeepWork = 'Online and in deep work',
  Offline = 'Offline',
  AwayFromKeyboard = 'Away from keyboard',
  DoNotDisturb = 'Do not disturb',
  Busy = 'Busy',
}

/**
 * Generic status for projects and tasks
 */
export enum Status {
  Draft = 'Draft',
  ToDo = 'To Do',
  InProgress = 'In Progress',
  Done = 'Done',
}

/**
 * Task type
 */
export enum TaskType {
  Task = 'Task',
  Milestone = 'Milestone',
  Approval = 'Approval',
}

/**
 * Task priority levels
 */
export enum Priority {
  None = 'None',
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
}

/**
 * Task horizon (time-based priority)
 */
export enum Horizon {
  None = 'None',
  Now = 'Now',
  Next = 'Next',
  Someday = 'Someday',
  Never = 'Never',
}

/**
 * Message status
 */
export enum MessageStatus {
  Draft = 'Draft',
  Published = 'Published',
  Archived = 'Archived',
  Deleted = 'Deleted',
}

/**
 * Document type
 */
export enum FileType {
  File = 'File',
  Folder = 'Folder',
  Image = 'Image',
  Video = 'Video',
  Audio = 'Audio',
  PDF = 'PDF',
  Document = 'Document',
  Spreadsheet = 'Spreadsheet',
  Presentation = 'Presentation',
  Code = 'Code',
  Other = 'Other',
}
